import {API, Setup} from '../../Services';

async function EventsData(){
    let mallId =  localStorage.getItem('mallId');
    let token =  localStorage.getItem('token');
    return API.get(`/malls/${mallId?mallId:Setup.default_malls}/blog_posts`,{
        headers: { 'Authorization':  `Bearer ${token}`},
        params:{
            post_type:'event',
            // is_introduction:false
        }
    });
}


export {EventsData};
